import { get, post } from '@js/common/api'
import { supportsLocalStorage } from '@js/common/utils'

const MIN_VALID_USER_DATA_AMOUNT = 2

export const UA = (() => {
  const getUserData = () => {
    get('users/current').then(data => {
      if (Object.keys(data.current_user).length > 0)
        setLS(data.current_user, 'storage')
    })
  }

  const isLoggedIn: () => boolean = function () {
    const UAToken = localStorage.getItem('UAToken')
    const UATokenExpires = localStorage.getItem('UATokenExpires')
    const UAData = localStorage.getItem('UA')

    if (UAToken === null) {
      return false
    }

    if (new Date(Number(UATokenExpires)) > new Date()) {
      return true
    }

    if (
      !UAData ||
      Object.keys(JSON.parse(UAData)).length < MIN_VALID_USER_DATA_AMOUNT
    ) {
      getUserData()
    }

    doLogOut()
    return false
  }

  const doLogIn: ({
    token,
    expires,
    public_id
  }: {
    token: string
    expires: string
    public_id?: string
  }) => void = function ({ token, expires, public_id }) {
    localStorage.setItem('UAToken', token)
    localStorage.setItem('UATokenExpires', expires)
    if (public_id) {
      const UAData = localStorage.getItem('UA')
      const UADataNotEmptyObject =
        UAData && Object.keys(JSON.parse(UAData)).length > 0
      if (UAData && UADataNotEmptyObject) {
        localStorage.setItem(
          'UA',
          JSON.stringify({ ...JSON.parse(UAData), public_id })
        )
      } else {
        localStorage.setItem('UA', JSON.stringify({ public_id }))
        getUserData()
      }
    }
  }

  const doLogOut: () => void = function () {
    localStorage.removeItem('UAToken')
    localStorage.removeItem('UATokenExpires')
    localStorage.removeItem('UA')
  }

  const getToken: () => string = function () {
    return localStorage.getItem('UAToken') || ''
  }

  const setLS: (
    userData: any,
    onStorageUpdateEvent?: string
  ) => void = function (userData = {}, onStorageUpdateEvent) {
    localStorage.setItem('UA', JSON.stringify(userData))
    if (onStorageUpdateEvent) {
      window.dispatchEvent(new Event(onStorageUpdateEvent))
    }
  }

  const getLS: () => any = function () {
    const LS = localStorage.getItem('UA') || '{}'
    let parsedLS = {}

    try {
      parsedLS = JSON.parse(LS)
    } catch (e) {}
    return parsedLS
  }

  const addFavourite: (houseNid: string) => void = function (houseNid) {
    let currentFavourites = getLS().ua_favourites || []
    const { email } = getLS()

    if (!email) return

    if (currentFavourites.length > 0) {
      currentFavourites.push({
        nid: houseNid,
        timestamp: new Date().toISOString()
      })
    } else {
      currentFavourites = [
        { nid: houseNid, timestamp: new Date().toISOString() }
      ]
    }

    setLS({
      ...getLS(),
      ua_favourites: currentFavourites
    })

    return post('users/current', {
      email,
      ua_favourites: currentFavourites
    })
  }

  const isFavourite: (houseNid: string) => boolean = function (houseNid) {
    const currentFavourites = getLS().ua_favourites || []

    return (
      currentFavourites.findIndex(
        (house: { [key: string]: string }) => house.nid === houseNid
      ) > -1
    )
  }

  const removeFavourite: (houseNid: string) => void = function (houseNid) {
    let currentFavourites = getLS().ua_favourites || []
    const { email } = getLS()

    if (!email) return

    currentFavourites = currentFavourites.filter(
      (house: { [key: string]: string }) => house.nid !== houseNid
    )

    setLS({
      ...getLS(),
      ua_favourites: currentFavourites
    })

    return post('users/current', {
      email,
      ua_favourites: currentFavourites
    })
  }

  const getCurrentUserState = () => {
    return getLS().ua_user_state
  }

  const userHasState = () => {
    return [
      'conversion_prequal',
      'conversion_non_prequal',
      'handover'
    ].includes(getLS().ua_user_state)
  }

  const isUserConverted = () => {
    return ['conversion_prequal', 'conversion_non_prequal'].includes(
      getLS().ua_user_state
    )
  }

  const isUserHandedOver = () => {
    return getLS().ua_user_state === 'handover'
  }

  const getUserLeads = async () => {
    try {
      const user = await get('users/current')

      if (user.current_user.ua_user_state === 'handover') {
        const leads = await get('users/current/leads/')

        const filteredVendorsData =
          Array.isArray(leads) && leads.length
            ? leads.filter((i: { vendor: any }) => i.vendor)
            : []

        return filteredVendorsData
      }
    } catch (error) {
      console.log(error)
    }
  }

  return {
    isLoggedIn: supportsLocalStorage() ? isLoggedIn : () => false,
    doLogIn: supportsLocalStorage() ? doLogIn : () => {},
    doLogOut: supportsLocalStorage() ? doLogOut : () => {},
    getToken: supportsLocalStorage() ? getToken : () => '',
    setLS: supportsLocalStorage() ? setLS : () => {},
    getLS: supportsLocalStorage() ? getLS : () => ({}),
    getUserData: supportsLocalStorage() ? getUserData : () => ({}),
    addFavourite: supportsLocalStorage() ? addFavourite : () => {},
    removeFavourite: supportsLocalStorage() ? removeFavourite : () => {},
    isFavourite: supportsLocalStorage() ? isFavourite : () => false,
    getCurrentUserState: supportsLocalStorage()
      ? getCurrentUserState
      : () => false,
    userHasState: supportsLocalStorage() ? userHasState : () => false,
    isUserConverted: supportsLocalStorage() ? isUserConverted : () => false,
    isUserHandedOver: supportsLocalStorage() ? isUserHandedOver : () => false,
    getUserLeads: supportsLocalStorage() ? getUserLeads : () => false
  }
})()
